import PropTypes from 'prop-types'
import { useContext } from 'react'
import { useLocation } from 'react-router-dom'
import ContenedorMenu from './ContenedorMenu'
import ContenedorPrincipal from './ContenedorPrincipal'
import { LoginContext } from './context/loginContext'
import withEsMovil from './hoc/withEsMovil'

const Cuerpo = ({ mostrarAyuda, cambiarImagenPerfil }) => {
  const location = useLocation()
  const { isAuthenticated } = useContext(LoginContext)

  return (
    <>
      {location.pathname.indexOf('Login') === -1 && isAuthenticated && (
        <div>
          <ContenedorMenu mostrarAyuda={mostrarAyuda} />
        </div>
      )}
      {
        <div
          className="main-content-container"
          style={{
            boxSizing: 'border-box', // Include padding in width calculation
            maxWidth: '100%', // Ensure it never exceeds viewport width
            width: '100vw',
            padding: '0 5vw'
          }}
        >
          <ContenedorPrincipal cambiarImagenPerfil={cambiarImagenPerfil} />
        </div>
      }
    </>
  )
}

Cuerpo.propTypes = {
  mostrarAyuda: PropTypes.func,
  cambiarImagenPerfil: PropTypes.func
}

export default withEsMovil(Cuerpo)
